import React, { Component, Fragment } from 'react';
import CryptoService from './../../../../server/cryptoService';
import { calculateUnionBankCharges, convertTwoDecimalPoint, groupBy, _addNotificationError } from '../../../../server/util';
import { postWithHeadersResponse } from '../../../../server/actions';
import { UPAY_URL, URL_VERSION3 } from '../../../../server/constants';
import moment from 'moment';
const PAYMOB_GATEWAY_URL=UPAY_URL;

class UnionPay extends Component {
    constructor(props){
        super(props);
        this.state={
            paymentToken:'',
            progress:false
        }
    }
    validateSchoolName=(school='')=>{
        const schoolsArray=[{name:'Institute of Culinary Management - British School Manila', shortName:'ICM - British School Manila'}];
        const schoolFindObj=schoolsArray.find(s=>{
            return s.name==school
        });
        if(schoolFindObj){
            return schoolFindObj.shortName
        }else{
            if(school.length>50){
                return school.substring(0, 50);
            }else{
                return school
            }
        }
    }
    validateStringLength=(text='')=>{
            if(text.length>50){
                return text.substring(0, 50);
            }else{
                return text
            }
        }
    onPayButtonClick=(e)=>{        
        const {formValues, paymentObj, userInfo, schoolName, studentData, postDataForUnionPay, paymentDesc}=this.props;
        const mealObject=postDataForUnionPay(); 
        this.setState({progress:true});
        if(paymentDesc==='LUNCH_BAL'){
            this.addLunchBalRequest().then(response=>{
                if (response.statusCode!==200) {
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 200) {
                    const groupByFormValues=groupBy(formValues||[],'name')||{};
                    console.log('props', res);
                    const billerUuid =((groupByFormValues.uuid||[])[0]||{}).value||'';
                    const key=((groupByFormValues.aesKey||[])[0]||{}).value||'';
                    const _cryptoService=new CryptoService();
                    const reqObject={
                        "Amt": parseFloat(convertTwoDecimalPoint(mealObject.totalTransactionAmount,2))+parseFloat(convertTwoDecimalPoint(mealObject.appFeeAmount,2)) ,
                        "Email":userInfo.parent,
                        "Redir":`${window.location.origin}/parent`,
                        References:[
                            {"Id":"1","Name":"FULL NAME","Val":`${userInfo.parent}`},
                            {"Id":"2","Name":"SCHOOL","Val": this.validateSchoolName(schoolName)},
                            {'Id':"3","Name":"ORDER REFERENCE NUMBER","Val":res.token}, 
                            {"Id":"4","Name":"EMAIL","Val":userInfo.parent},                      
                            {"Id":"5","Name":"ORDER DATE","Val":moment().format('DD-MM-YYYY')}
                        ]            
                    };
                    const jsonData=JSON.stringify(reqObject);
                    const cipher=_cryptoService.encryptAES(jsonData,key) ;
                    const url=`${PAYMOB_GATEWAY_URL}/${billerUuid}?s=${cipher}`;
                    window.location=url;
                    this.setState({progress: false});
                }}).catch(
                    (error) => {
                        this.setState({progress: false});
                       // _addNotificationError(error.message, this)
                       alert(error.message);
                        console.log('Meal order Creation Error', error)
                    }
                );


        }else if(paymentDesc==='ORDER_PAY'){
            this.postOrderRequest().then(response=>{
                if (response.statusCode!==200) {
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 200) {
                    const groupByFormValues=groupBy(formValues||[],'name')||{};
                    console.log('props', res);
                    const billerUuid =((groupByFormValues.uuid||[])[0]||{}).value||'';
                    const key=((groupByFormValues.aesKey||[])[0]||{}).value||'';
                    const _cryptoService=new CryptoService();
                    const reqObject={
                        "Amt": parseFloat(convertTwoDecimalPoint(mealObject.instantPayAmt,2))+parseFloat(convertTwoDecimalPoint(mealObject.appFeeAmount,2)) ,
                        "Email":userInfo.parent,
                        "Redir":`${window.location.origin}/parent`,
                        References:[
                            {"Id":"1","Name":"FULL NAME","Val":this.validateStringLength(`${studentData.lastName} ${studentData.firstName}`)},
                            {"Id":"2","Name":"SCHOOL","Val":this.validateSchoolName(schoolName)},
                            {'Id':"3","Name":"ORDER REFERENCE NUMBER","Val":res.token}, 
                            {"Id":"4","Name":"EMAIL","Val":userInfo.parent},                      
                            {"Id":"5","Name":"ORDER DATE","Val":(paymentObj||{}).orderDate.format('DD-MM-YYYY')}
                        ]            
                    };
                    const jsonData=JSON.stringify(reqObject);
                    const cipher=_cryptoService.encryptAES(jsonData,key) ;
                    const url=`${PAYMOB_GATEWAY_URL}/${billerUuid}?s=${cipher}`;
                    window.location=url;
                    this.setState({progress: false});
                }}).catch(
                    (error) => {
                        this.setState({progress: false});
                       // _addNotificationError(error.message, this)
                       alert(error.message);
                        console.log('Meal order Creation Error', error)
                    }
                );

        }else{

        }
        
    }
    addLunchBalRequest=()=>{
        const {postDataForUnionPay}=this.props;
        const mealObject=postDataForUnionPay(); 
        let headers = {
            'Content-Type': 'application/json'
        };
        return postWithHeadersResponse("/transactions/depositAmtThruOnline?access_token=", JSON.stringify(mealObject),headers);        
    }
    postOrderRequest=()=>{
        const {studentData, mealType, postDataForUnionPay}=this.props;
        const mealObject=postDataForUnionPay(); 
        const reqObject={
            studentId:mealObject.studentId,
            paymentType: "Online",
            calIdWCountByMonth:mealObject.calIdWCountByMonth,
            instantPayAmt: mealObject.instantPayAmt,
            transactionFees: mealObject.transactionFees,
            appFeeAmount: mealObject.appFeeAmount,
            //donationAmt: 15,
            //donationNoOfMeals: "3",
            walletAmt: mealObject.walletAmt
        };
        let headers = {
            'Content-Type': 'application/json'
        };
        return postWithHeadersResponse(`${URL_VERSION3}/orderMenu/${mealType}?studentRecId=${reqObject.studentId}&access_token=`, JSON.stringify(reqObject),
        headers);
    }
    renderPaymentButton=()=>{             
        return (
            <Fragment>
               <button type='button' className="btn btn-sm btn-success" style={{margin:'0px 0px 0px 5px'}} disabled={this.state.progress} 
               onClick={this.onPayButtonClick}><i className="glyphicon glyphicon-ok"></i> Pay With Card</button>                
            </Fragment>
        );
    }
    render(){
        return this.renderPaymentButton()
    }
}

export default UnionPay;


// WEBPACK FOOTER //
// ./src/components/Misc/PaymentModule/unionPay/index.jsx